import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Widgetcreateupdate from "./Widgetcreateupdate";
import { updateeditwidgetdetails } from "../../../store/cofig_data";
import Defaultbasicprops from "./Defaultbasicprops";
import { Switch as AntdSwitch } from "antd";
import { updatetheme } from "../../../store/theme_data";
import "../../../cssfiles/homepage.css";
import { ConfigProvider } from "antd";

export default function Widgetlist(props) {
  const dispatch = useDispatch();
  var mainwidgetlist = ["Card", "Charts", "Gauge", "Table", "Control", "Map"];
  var cardlist = ["Single Value", "Multi Value", "Status Card"];
  var cahrtlist = ["Line Chart", "Bar Chart", "Area Chart", "Pie Chart"];
  var Gaugelist = [
    "Circular Gauge",
    "Semi Circular Gauge",
    "Linear Gauge",
    "Speed Gauge",
    "Temperature Gauge",
  ];
  var Tablelist = ["Timeseries Table"];
  var Controllist = ["Status", "Switch", "Set Value"];
  var Maplist = ["Google Map"];

  const theme = useSelector((state) => state.themedata.theme);
  const [list, setList] = useState(mainwidgetlist);
  const [subList, setSubList] = useState([]);
  const [mainlistflag, setMainlistflag] = useState(false);
  const [widgetpropflag, setWidgetpropflag] = useState(false);
  const [toggleval, setToggleval] = useState(false);
  const [selectedwidget, setSelectedwidget] = useState("");
  useEffect(() => {
    if (theme === "dark") {
      setToggleval(true);
    } else {
      setToggleval(false);
    }
  }, [theme]);

  const handleonwidgetclick = (widgetname) => {
    
    setSelectedwidget(widgetname);
    switch (widgetname) {
      case "Card":
        setSubList(cardlist);
        // setMainlistflag(true);
        props.callbackselection("sub list", "Card");
        if (widgetpropflag) {
          setWidgetpropflag(false);
        }
        break;
      case "Charts":
        setSubList(cahrtlist);
        // setMainlistflag(true);
        props.callbackselection("sub list", "Charts");
        if (widgetpropflag) {
          setWidgetpropflag(false);
        }
        break;
      case "Gauge":
        setSubList(Gaugelist);
        // setMainlistflag(true);
        props.callbackselection("sub list", "Gauge");
        if (widgetpropflag) {
          setWidgetpropflag(false);
        }
        break;
      case "Table":
        setSubList(Tablelist);
        // setMainlistflag(true);
        props.callbackselection("sub list", "Table");
        if (widgetpropflag) {
          setWidgetpropflag(false);
        }
        break;
      case "Control":
        setSubList(Controllist);
        // setMainlistflag(true);
        props.callbackselection("sub list", "Control");
        if (widgetpropflag) {
          setWidgetpropflag(false);
        }
        break;
      case "Map":
        setSubList(Maplist);
        // setMainlistflag(true);
        props.callbackselection("sub list", "Map");
        if (widgetpropflag) {
          setWidgetpropflag(false);
        }
        break;
      default:
        // setMainlistflag(true);
        setWidgetpropflag(true);
        props.callbackselection("props setting", widgetname);
    
        var basicprops = Defaultbasicprops;
        var extendprops = {};
        dispatch(updateeditwidgetdetails(widgetname, basicprops, extendprops));
        break;
    }
  };

  const handlebacktomain = () => {
    setList(mainwidgetlist);
    // setMainlistflag(false);
    setWidgetpropflag(false);
    // props.callbackselection("main list", "");
  };

  const handlethemetoggel = (checked) => {
    if (checked) {
      setToggleval(checked);
      dispatch(updatetheme("dark"));
    } else {
      setToggleval(checked);
      dispatch(updatetheme("light"));
    }
  };

  return (
    <div
      style={{
        height: "calc(100% - 60px)",
        width: "calc(100% - 20px)",
        padding: "10px",
      }}
    >
  
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          {/* <button
            style={{
              padding: "8px 20px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "#005C8E",
              color: "#FFFFFF",
              //padding: '8px 45px',
              border: "none",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",

              marginRight: "20px",
            }}
            onClick={handlebacktomain}
          >
            Main List
          </button> */}
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: 400,
              marginLeft: "20px",
              marginRight: "5px",
            }}
          >
            Dark Mode
          </Typography>
          <ConfigProvider
            theme={{
              token: {
                //colorBgContainer:'#000000',
                motionDurationMid: "0.2s",
                borderRadius: "20px",
                colorPrimary: "#005C8E",
                colorSecondary: "#000000",
              },
              components: {
                Switch: {
                  //borderColor:'var(--SecondaryText)',
                  //trackBg:'#ffffff',
                  trackHeight: "28px",
                  trackMinWidth: "58px",
                  handleShadow: "0px",
                  handleBg: theme == "light" ? "#EFEFEF" : "#E0E0E0",
                  handleSize: 20,
                  trackPadding: 4,
                },
              },
            }}
          >
            <AntdSwitch
              value={toggleval}
              defaultChecked={false}
              onChange={handlethemetoggel}
            />
          </ConfigProvider>
        </div>
      
      {widgetpropflag ? (
        <Widgetcreateupdate type={"New"} />
      ) : (
        // <Grid container spacing={2} >
        //     {
        //         list.map(widget => {
        //             return(
        //                 <Grid item xs={3}>
        //                     <div elevation={0}
        //                         style={{
        //                             backgroundColor: theme === 'dark' ? '#1E1E1E' : '#FFFFFF',
        //                             borderRadius: '0px',
        //                             border: '1px soild',
        //                             height: '250px',
        //                             width: '320px',
        //                             display: 'flex',
        //                             alignItems: 'center',
        //                             justifyContent: 'center'
        //                         }}
        //                         onClick={() => handleonwidgetclick(widget)}
        //                     >
        //                         <Typography sx={{marginLeft: '15px',marginTop:"8px", color: '#008CD7', fontSize: '16px', fontWeight: 700, fontFamily:"Roboto"}}> {widget} </Typography>
        //                     </div>
        //                 </Grid>
        //             )
        //         })
        //     }
        // </Grid>

        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              {list.map((widget) => (
                  <div
                    elevation={0}
                    style={{
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#FFFFFF",
                      borderRadius: "0px",
                      border: "1px soild",
                      height: "100px",
                      width: "200px",
                      margin: "10px 5px",
                      display: "flex",
                      alignItems: "center",
                      // background:"orange",
                      justifyContent: "center",
                      cursor: "pointer",
                     fontWeight: selectedwidget === widget ? 700 : 400,
                     color: selectedwidget === widget ? "#008CD7" : "#000000",
                    }}
                    onClick={() => handleonwidgetclick(widget)}
                  >
                    {widget}
                  </div>
                ))}
            </Grid>
            <Grid
              item
              xs={10}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {subList.length > 0 ? (
                <div
                  style={{
                      display: "flex",
                          maxWidth: "75%",
                          flexWrap: "wrap"
                  }}
                >
                  {subList.map((widget) => {
                    return (
                      <div
                        elevation={0}
                        style={{
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#FFFFFF",
                          borderRadius: "0px",
                          border: "1px soild",
                          height: "90px",
                          width: "150px",
                          margin: "10px 5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => handleonwidgetclick(widget)}
                      >
                        {widget}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div>Select a widget</div>
              )}
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
}
